// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ba423de0","455":"74d5d52b","977":"6f2c1e49"}[chunkId] + ".chunk.js";
};